import { ErrorMessage } from "formik";
import React from "react";

export default function TextArea({ field, form, ...props }) {
    return (
        <div className={"form-group input-group-lg col-md-" + (props.colNumber || 4)}>
            <label className="text-black font-w600">
                {props.label}
                {props.required ? "*" : ""}
            </label>
            <textarea className="form-control"
                placeholder={props.label}
                // style={{ height: "calc(1.5em + 1rem + -4px)" }}
                {...field}
                {...props} 
                value={field.value ? field.value : ""}
                />
            <ErrorMessage
                name={field.name}
                render={(msg) => (
                    <span className="text-danger">
                        <small>*{msg}</small>
                    </span>
                )}
            />
        </div>
    );
}
